import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setSessionEndedHandler, isPublicAuthPath } from "@/lib/authSession";

/** Registers router navigation for logout and session expiry. Mount inside BrowserRouter. */
export function AuthSessionBridge() {
  const navigate = useNavigate();

  useEffect(() => {
    setSessionEndedHandler(() => {
      if (isPublicAuthPath()) return;
      navigate("/login", { replace: true });
    });
    return () => setSessionEndedHandler(null);
  }, [navigate]);

  return null;
}
